function changeFooterPosition(){
  var id = jQuery('#shopify-section-footer'), pageHeight = jQuery('.page').height(), winHeight = jQuery(window).height();
  if(pageHeight >=winHeight){
    id.addClass('active');
  } else {
    id.removeClass('active');
  }
}
jQuery(document).ready(function() {
  changeFooterPosition();
})
jQuery(window).resize(function() {
  changeFooterPosition();
})